import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { ValueTypeConfirmDialogContent } from './ValueTypeConfirmDialogContent'

interface IProps {
  onConfirm: () => Promise<void>
  onClose: () => void
  show: boolean
  errorTranslationKey?: string
  translationKey: string
  actualsValueType: string
}

export const ValueTypeConfirmDialog = ({
  onClose,
  show,
  onConfirm,
  errorTranslationKey,
  translationKey,
  actualsValueType,
}: IProps) => {
  const contentProps = useMemo(
    () => ({
      onConfirm,
      onClose,
      errorTranslationKey,
      translationKey,
      actualsValueType,
    }),
    [actualsValueType, errorTranslationKey, onClose, onConfirm, translationKey]
  )

  return (
    <ModalDialog
      size={'xs'}
      content={ValueTypeConfirmDialogContent}
      contentProps={contentProps}
      show={show}
      onClose={onClose}
    />
  )
}
